export const ServiceAction = Object.freeze({
  ADDED: 'added',
  UPDATED: 'updated'
});

export default ServiceAction;